import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { Tag, Col, Icon, Cell, CellGroup, Swipe, Toast, SwipeItem, ActionBar, ActionBarIcon, ActionBarButton } from 'vant';
import { ref } from 'vue';
import 'vant/es/toast/style';
import axios from 'axios';
import { areaList } from '@vant/area-data';
import { getUserInfo, rechargePhone, rechargePower, sendOauth } from '../../api/user';
import Storage from "../../utils/Storage";
export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ActionBar.name]: ActionBar,
    [ActionBarIcon.name]: ActionBarIcon,
    [ActionBarButton.name]: ActionBarButton,
    [ref.name]: ref
  },
  created() {
    if (this.$route.query.code !== undefined) {
      let params = {
        code: this.$route.query.code,
        access_token: this.$route.query.state
      };
      // axios.post('',params).then(result => {
      //   alert('login')
      //   console.log(params);
      //   return;
      //
      // }).catch(err => {
      //       alert('请先点击确定,再点击右下角使用完整服务')
      // })

      sendOauth(params).then(result => {
        Storage.set('users', result.token);
        // if(result.status == 2){
        //     this.$store.commit("UPDATEUSERS",result.data);
        //     let path = this.$storage.get("VUE_REFERER");
        //     this.$storage.delete("VUE_REFERER");
        //     if(!path){
        //         path = "/";
        //     }
        //     path = "/";
        //     // this.$router.push('/');
        // }else{
        //     Toast(result.info);
        //     // this.$router.push('/');
        // }
        getUserInfo().then(response => {
          this.wallet = response.data.wallet;
        });
      }).catch(err => {
        alert('请先点击确定,再点击右下角使用完整服务');
      });
      return;
    }
    getUserInfo().then(response => {
      this.wallet = response.data.wallet;
    });
  },
  setup() {
    const result = ref('');
    const showArea = ref(false);
    const onConfirm = areaValues => {
      showArea.value = false;
      result.value = areaValues.filter(item => !!item).map(item => item.name).join('/');
    };
    return {
      result,
      areaList,
      showArea,
      onConfirm
    };
  },
  watch: {
    telephone(newVal) {
      if (!/^1[3456789]\d{9}$/.test(newVal)) {
        this.address = '';
        return;
      }
      this.address = '手机号格式正确';
      // this.address = newVal

      // this.address = "山东 临沂 中国联通";
      // this.ISP = 'LT';
      // return

      // axios.get('http://aiphone.market.alicloudapi.com/ai_mobile_number_belong_to_china/v1?MOBILE_NUMBER=' + newVal, {
      //   headers: {
      //     'Authorization': "APPCODE 34cc6cf679574c01ada4742e34f23b61",
      //   }
      // }).then(res => {
      //   if (res.status !== 200 || res.statusText !== "OK") {
      //     return
      //   }
      //   res = res.data;
      //   this.address = res.ENTITY.PROVINCE + " " + res.ENTITY.CITY + " " + res.ENTITY.ISP
      //   console.log(this.address)
      // })
    },
    result(newVal) {
      let area = newVal.split('/')[0];
      // if (area == '四川省'||area == '北京市' || area == '上海市'){
      //   this.pricePowerList = [
      //     {'rechargePrice': "电费 100", 'payPrice': '96 元', 'price': 100, 'dk': 4, 'type_id': 63},
      //     {'rechargePrice': "电费 200", 'payPrice': '191 元', 'price': 200, 'dk': 9, 'type_id': 64},
      //     {'rechargePrice': "电费 1000", 'payPrice': '286 元', 'price': 300, 'dk': 14, 'type_id': 66},
      //   ];
      //   this.power.electricardtype = ref('1');
      // }else
      if (area == '广西壮族自治区' || area == '广东省' || area == '云南省' || area == '贵州省' || area == '海南省') {
        this.pricePowerList = [{
          'rechargePrice': "电费 100",
          'payPrice': '94.50 元',
          'price': 100,
          'dk': 5.5,
          'type_id': 1
        }, {
          'rechargePrice': "电费 200",
          'payPrice': '189.00 元',
          'price': 200,
          'dk': 11,
          'type_id': 2
        }, {
          'rechargePrice': "电费 300",
          'payPrice': '283.50 元',
          'price': 300,
          'dk': 17,
          'type_id': 48
        }];
        this.power.electricardtype = ref('2');
      } else {
        this.power.electricardtype = ref('1');
        this.pricePowerList = [{
          'rechargePrice': "电费 100",
          'payPrice': '95.50 元',
          'price': 100,
          'dk': 4.5,
          'type_id': 16
        }, {
          'rechargePrice': "电费 200",
          'payPrice': '191.00 元',
          'price': 200,
          'dk': 9,
          'type_id': 17
        }, {
          'rechargePrice': "电费 1000",
          'payPrice': '955.00 元',
          'price': 1000,
          'dk': 45,
          'type_id': 25
        }];
      }
    }
  },
  //https://cloud.baidu.com/search.html?q=%E6%89%8B%E6%9C%BA%E5%8F%B7%E5%BD%92%E5%B1%9E&type=market&pn=1
  data() {
    return {
      wallet: 0,
      goods: {
        title: '美国伽力果（约680g/3个）',
        price: 2680,
        express: '免运费',
        remain: 19,
        thumb: ['https://img.yzcdn.cn/public_files/2017/10/24/e5a5a02309a41f9f5def56684808d9ae.jpeg', 'https://img.yzcdn.cn/public_files/2017/10/24/1791ba14088f9c2be8c610d0a6cc0f93.jpeg']
      },
      active_num: 1,
      address: '',
      telephone: '',
      priceList: {
        'YD': [{
          'rechargePrice': "话费 100",
          'payPrice': '95 元',
          'price': 100,
          'dk': 5
        }, {
          'rechargePrice': "话费 200",
          'payPrice': '190 元',
          'price': 200,
          'dk': 10
        }],
        'LT': [{
          'rechargePrice': "话费 100",
          'payPrice': '93 元',
          'price': 100,
          'dk': 7
        }, {
          'rechargePrice': "话费 200",
          'payPrice': '186 元',
          'price': 200,
          'dk': 14
        }, {
          'rechargePrice': "话费 300",
          'payPrice': '273 元',
          'price': 300,
          'dk': 27
        }]
      },
      pricePowerList: [{
        'rechargePrice': "电费 100",
        'payPrice': '95.50 元',
        'price': 100,
        'dk': 4.5,
        'type_id': 16
      }, {
        'rechargePrice': "电费 200",
        'payPrice': '191.00 元',
        'price': 200,
        'dk': 9,
        'type_id': 17
      }, {
        'rechargePrice': "电费 1000",
        'payPrice': '955.00 元',
        'price': 1000,
        'dk': 45,
        'type_id': 25
      }],
      // priceList:[
      //   [
      //     {'rechargePrice': "话费 100", 'payPrice': '95 元', 'price': 100},
      //     {'rechargePrice': "话费 100", 'payPrice': '190 元', 'price': 200},
      //     {'rechargePrice': "话费 100", 'payPrice': '185 元', 'price': 300},
      //   ]
      // ],
      ISP: 'YD',
      power: {
        electricardtype: 0,
        electritype: 0,
        number: '',
        area: '',
        telephone: '',
        cardno: '',
        amount: 0.00
      },
      active_num2: 1,
      active_num_power: 1
    };
  },
  methods: {
    formatPrice() {
      return '¥' + (this.goods.price / 100).toFixed(2);
    },
    onClickCart() {
      this.$router.push('cart');
    },
    sorry() {
      Toast('暂无后续逻辑~');
    },
    onSwitch(val) {
      this.active_num = val;
      console.log(this.active_num);
    },
    onSwitch2(val) {
      this.active_num2 = val;
      switch (val) {
        case 1:
          this.ISP = 'YD';
          break;
        case 3:
          this.ISP = 'LT';
          break;
        case 2:
          this.ISP = 'LT';
          break;
      }
    },
    onSubmit() {
      this.power.area = this.result;
      this.power.amount = this.pricePowerList[this.active_num_power - 1]['price'];
      this.power.type_id = this.pricePowerList[this.active_num_power - 1]['type_id'];
      // let regex = /^((\+)?86|((\+)?86)?)0?1[3458]\d{9}$/;
      // if (!this.power.telephone.match(regex)) {
      //   Toast('手机号码不正确');
      //   return
      // }
      this.power.recharge_type = 'power';
      console.log(this.power);
      if (this.wallet < this.pricePowerList[this.active_num_power - 1]['dk']) {
        Toast("可用抵扣额度不足，请先冲卡");
        return;
      }
      rechargePower(this.power).then(response => {
        WeixinJSBridge.invoke('getBrandWCPayRequest', response, function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            console.log(res.err_msg);
            Toast("支付成功");
            setTimeout(() => {
              that.$router.replace('/order');
            }, 1500);
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            console.log(res.err_msg);
          }
        });
      }).catch(() => {
        Toast.fail('输入内容错误请重试');
      });
    },
    telSubmit() {
      let data = {
        telephone: this.telephone,
        isp: this.active_num2,
        amount: this.priceList[this.ISP][this.active_num - 1]['price'],
        recharge_type: 'telephone'
      };
      // Toast("话费充值功能维护，暂时暂停充值");
      // return
      if (data.isp == 1 && data.amount > 100) {
        Toast("移动,电信200面额暂未开通");
        return;
      }
      if (data.isp == 2 && data.amount > 100) {
        Toast("移动,电信200面额暂未开通");
        return;
      }
      if (data.amount > 200) {
        Toast("话费300面额暂未开放充值");
        return;
      }
      // var regex = /^((\+)?86|((\+)?86)?)0?1[3458]\d{9}$/;
      // if (!data.telephone.match(regex)) {
      //   Toast('手机号码不正确');
      //   return
      // }
      // appId: "wxfb914edfff523bfe"
      // nonceStr: "vaWCRD8Kcwi6W8BL"
      // package: "prepay_id=wx1414174411416298a74a179b2b3b1a0000"
      // paySign: "D0258550444D4113623264FA16BFC6A6"
      // signType: "MD5"
      // timeStamp: "1663136263"
      rechargePhone(data).then(response => {
        Toast.success('订单提交成功');
        var that = this;
        console.log(['data', response]);
        WeixinJSBridge.invoke('getBrandWCPayRequest', response, function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            console.log(res.err_msg);
            Toast("支付成功");
            setTimeout(() => {
              that.$router.replace('/order');
            }, 1500);
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            console.log(res.err_msg);
          }
        });
      }).catch(() => {
        Toast.fail('输入内容错误请重试');
      });
    }
  }
};